// PHA-1168: wording for a report's scope, shared by the report lists.
import type { ReportScope } from '../../services/api';

export const scopeLabel = (scope: ReportScope | undefined, organizationName: string | null): string => {
  if (scope === 'phanova') return 'Phanova-wide';
  if (scope === 'network') return `From ${organizationName || 'network'}`;
  return 'Clinic';
};

export const SCOPE_COLOR: Record<ReportScope, 'gray' | 'blue' | 'purple'> = {
  clinic: 'gray',
  network: 'blue',
  phanova: 'purple',
};
